import React from "react";
import Header from '../components/Header';
import Footer from '../components/Footer';
import ProductsList from '../DropshipperPages/ProductsList';
import "./PublicProductView.css";

const PublicProductView = () => {
  return (
    <div className="public-product-view-page shared-background">
      <div className="public-product-view-inner">
        <Header />
        <section className="public-product-view-section">
          <div className="public-product-view-panel">
            <ProductsList />
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default PublicProductView;